import React from 'react';

import { Tab } from '../../../../../tabs/tabs';
import Typography from '../../../../../typography/typography';

import './fitment-tab.scss';

interface FitmentTabProps {
  label: string;
  onClick?: (label: string) => void;
  selectedTab?: string;
}

function FitmentTab(props: FitmentTabProps) {
  const { label, selectedTab, onClick } = props;
  const isSelected = label === selectedTab;

  return (
    <Tab
      isSelected={isSelected}
      onClick={() => onClick?.(label)}
      styleName="tab"
    >
      <Typography styleName="shop-by" tag="span">
        Shop by
      </Typography>
      &nbsp;{label}
    </Tab>
  );
}

export default FitmentTab;
